var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDroplet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.38 4.07c-4.22.09-5.44 4.69-6.95 8.45s-10.5 24.21-16.32 34.53s-13.7 23.84-12.58 43.17c1.13 19.33 16.14 33.76 37.17 33.6c19.01-.14 35.64-11.1 36.32-34.91c.56-19.71-10.28-36.74-15.63-47.16c-3.18-6.2-13.59-26.95-14.69-29.52c-1.97-4.6-2.81-8.26-7.32-8.16z",
    fill: "#4ec1f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.38 64.42c-2.96.13-10 9.29-10 20.84s5.45 20.08 11.4 18.86c6.9-1.41 5.77-8.45 4.36-14.08c-1.21-4.84-3.1-10.56-3.52-15.77c-.26-3.37.86-9.99-2.24-9.85z",
    fill: "#b3e2fb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDroplet);
export default __webpack_public_path__ + "static/media/droplet.c6a4e9d50edb07be18b3cbe85899555e.svg";
export { ForwardRef as ReactComponent };